<template>
  <div :class="{ 'border-transparent': isModalOpen }">
    <section ref="customContainer" class="custom-container mx-auto">
      <div class="grid h-[inherit] md:grid-cols-16 grid-cols-none">
        <div class="col-span-16 h-[inherit] grid md:grid-cols-16 grid-cols-none">
          <div v-if="!isLeftBarHiddenForCurrentRoute" :class="[leftSpan]" class="md:h-[inherit]">
            <UiOnClickOutside :do="closeMobileLeftBar">
              <LeftBar
                :class="[$style.leftBar, { mobileLeftBar: tabLeftNav }]"
                :left-bar-visibility="tabLeftNav"
                @handleClick="handleClick"
              ></LeftBar>
            </UiOnClickOutside>
          </div>
          <div class="h-[inherit] overflow-y-hidden grid" :class="[mainContentGrids]">
            <AppHeader
              ref="headerContainer"
              class="order-2 sm:order-1"
              :show-right-bar-icon="true"
              @mobileLeftBar="mobileLeftBar"
            />
            <div
              class="order-1 sm:order-2"
              :class="['grid overflow-y-scroll', centerGrid]"
              :style="contentHeight"
            >
              <div
                :class="[centerSpan, $style.mainContentGutters]"
                class="xl:pl-6 pl-4 xl:pt-6 md:pt-5 pt-2.5 pr-4 xl:pr-4 pb-4"
              >
                <slot />
                <router-view />
              </div>

              <!-- Right Bar -->
              <div v-if="tabRightNav || rightbarHidden" class="xl:contents hidden">
                <UiOnClickOutside :do="closeMobileRightBar">
                  <RightBar
                    :class="[
                      { mobileRightBar: isMobileRightBar, 'ltr:ml-0 rtl:mr-0': tabRightNav },
                    ]"
                    :right-bar-visibility="isMobileRightBar"
                  />
                </UiOnClickOutside>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Overlay -->
    <div
      class="sidebar-overlay fixed top-0 left-0 w-full h-full z-[5000] overflow-hidden"
      :class="showOverlay"
    />

    <!-- Role Switching Modal -->
    <RoleSwitchingSuiteModal />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UiOnClickOutside from '@components/UiElements/UiOnClickOutside.vue'
import LeftBar from '@/src/router/layouts/left-bar/LeftBar.vue'
import RightBar from '@layouts/rightBar.vue'
import AppHeader from '@src/router/layouts/feed/Header.vue'
import { getDefaultRoute } from '@utils/generalUtil'
import RoleSwitchingSuiteModal from '@src/router/views/admin/modals/RoleSwitchingSuiteModal.vue'
import DEFAULT_LAYOUT_DATA from '@/src/router/layouts/defaultLayout.json'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import { SCOPE_LEVELS } from '@src/constants/general-constants.js'
import {
  checkIsTabView,
  checkIsMobileView,
  checkIsLaptopView,
  isCapacitor,
} from '@src/utils/platformUtil.js'
import { leftBarHiddenForCurrentRoute, getLevelVisibility } from '@/src/utils/layoutUtils.js'
import { FEATURES_ENVIRONMENT } from '@src/services/.env.js'
import { isTawkToAllowed, showTawkWidget, hideTawkWidget } from '@src/utils/widgetUtil.js'
export default {
  components: {
    LeftBar,
    RightBar,
    AppHeader,
    UiOnClickOutside,
    RoleSwitchingSuiteModal,
  },
  data() {
    return {
      campusesNotAllowedFor: ['pickup_person'],
      authenticRoute: null,
      headerOffSetHeight: 99,
      windowHeight: window.innerHeight,
      FEATURES_ENVIRONMENT,
    }
  },
  page: {
    title: 'Layout',
    meta: [{ name: 'description', content: 'Default Layout of MyQampus' }],
  },
  computed: {
    ...mapState({
      tabRightNav: (state) => state.layout.tabRightNav,
      tabLeftNav: (state) => state.layout.tabLeftNav,
      isModalOpen: (state) => state.layout.isModalOpen,
      currentCampusScope: (state) => state.layout.currentCampusScope,
      currentSectionScope: (state) => state.layout.currentSectionScope,
      currentClassScope: (state) => state.layout.currentClassScope,
      LeftBarClassList: (state) => state.layout.doRerenderLayout,
      activeRole: (state) => state.layout.activeRole,
      campuses: (state) => state.layout.campuses,
      leftBarContent: (state) => state.layout.leftBarContent,
      isAppLoading: (state) => state.layout.isAppLoading,
      isTabView: (state) => state.layout.isTabView,
      isLaptopView: (state) => state.layout.isLaptopView,
    }),
    isCapacitorApp() {
      return isCapacitor()
    },
    showOverlay() {
      return this.tabLeftNav ? 'block md:hidden' : 'hidden'
    },

    rightbarHidden() {
      let isRightBarActive
      isRightBarActive = DEFAULT_LAYOUT_DATA.rightBarHiddenFor.includes(this.$route.name)
      if (!isRightBarActive)
        return (isRightBarActive = DEFAULT_LAYOUT_DATA.RightBarActive.includes(this.$route.path))
      return isRightBarActive
    },
    isLeftBarHiddenForCurrentRoute() {
      return leftBarHiddenForCurrentRoute(this.$route.name)
    },
    isMobileRightBar() {
      return this.rightbarHidden ? false : this.tabRightNav
    },

    centerGrid() {
      return this.tabLeftNav ? 'grid-cols-13' : 'grid-cols-16 md:grid-cols-[repeat(15,_1fr)]'
    },

    centerSpan() {
      if ((!this.tabRightNav || this.rightbarHidden) && !this.tabLeftNav)
        return 'col-span-16 md:col-span-15 overflow-x-auto'
      if (!this.tabLeftNav) return 'col-span-16 md:col-span-15 xl:col-[span_12/span_12]'
      if (!this.tabRightNav || this.rightbarHidden) return 'col-span-16 md:col-span-13'
      return 'col-span-16 md:col-span-13 xl:col-span-10'
    },

    mainContentGrids() {
      let styleValue
      if ((!this.tabRightNav || this.rightbarHidden) && !this.tabLeftNav) {
        styleValue = 'md:col-span-15 col-span-16  overflow-x-auto'
      } else if (!this.tabLeftNav && !this.isLeftBarHiddenForCurrentRoute) {
        styleValue = 'col-span-16 md:col-span-15  overflow-x-auto'
      } else if (!this.tabRightNav || this.rightbarHidden) {
        styleValue = 'col-span-16 md:col-span-12 xl:col-span-13'
      } else if (this.isLeftBarHiddenForCurrentRoute) {
        styleValue = 'col-span-16'
      } else {
        styleValue = 'col-span-16 md:col-span-12 xl:col-span-13'
      }
      return styleValue
    },

    leftSpan() {
      return this.tabLeftNav ? 'xl:col-span-3 md:col-span-4' : 'md:col-span-1'
    },

    gutterContentStyle() {
      return { 'max-height': `calc(100% - ${this.headerOffSetHeight}px)` }
    },

    isInstituteLevelChange() {
      return this.currentCampusScope?.id + this.currentSectionScope?.id + this.currentClassScope?.id
    },

    isAdmin() {
      return [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN].includes(this.activeRole)
    },
    contentHeight() {
      return {
        height: `${this.windowHeight - this.headerOffSetHeight}px`,
      }
    },
  },

  watch: {
    activeRole: {
      immediate: true,
      handler() {
        this.applyNativeTawkBehavior()
      },
    },
    // This code is commented out so it can be used later.
    // currentCampusScope: {
    //   handler(value) {
    //     if (!value) this.checkLevelAuthentication(SCOPE_LEVELS.ROOT_LEVEL)
    //     else this.checkLevelAuthentication(SCOPE_LEVELS.CAMPUS_LEVEL)
    //   },
    // },
    // currentCampusScope(val) {
    //   this.checkLevelAuthentication(val ? SCOPE_LEVELS.CAMPUS_LEVEL : SCOPE_LEVELS.ROOT_LEVEL)
    // },
    // currentClassScope(val) {
    //   this.checkLevelAuthentication(val ? SCOPE_LEVELS.CLASS_LEVEL : SCOPE_LEVELS.CAMPUS_LEVEL)
    // },
    // currentSectionScope(val) {
    //   this.checkLevelAuthentication(val ? SCOPE_LEVELS.SECTION_LEVEL : SCOPE_LEVELS.CLASS_LEVEL)
    // },

    '$route.name'(name) {
      if (this.leftBarContent?.routes?.length) {
        this.findFeatureNameByRoute(this.leftBarContent.routes, name)
      }
    },
    leftBarContent: {
      immediate: true,
      handler(val) {
        if (val?.routes?.length && this.$route?.name) {
          this.findFeatureNameByRoute(val.routes, this.$route.name)
        }
      },
    },
    $route: {
      immediate: true,
      handler() {
        this.handleResize()
      },
    },
    isInstituteLevelChange: {
      immediate: true,
      handler() {
        this.getInstituteStats()
      },
    },
  },

  created() {
    this.setRightbarContent({
      stats: [
        {
          title: 'University',
          categories: [
            { text: 'Campuses', value: '--' },
            { text: 'Students', value: '--' },
          ],
        },
      ],
    })

    if (this.currentSectionScope && this.currentCampusScope) this.setCampusData()
    if (!this.campusesNotAllowedFor.includes(this.activeRole)) this.fetchInitialCampus()

    window.addEventListener('resize', this.handleResize)
  },

  mounted() {
    checkIsTabView()
    checkIsMobileView()
    checkIsLaptopView()
    document.body.style.overflowY = 'hidden'
    this.handleResize()
    this.setCustomContainerHeight()
    this.getHeaderContainerHeight()
    this.setTawkWidgetPosition()
    this.applyNativeTawkBehavior()
  },

  beforeUnmount() {
    document.body.style.overflowY = 'auto'
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    getLevelVisibility,
    handleResize() {
      this.windowHeight = window.innerHeight
      this.getHeaderContainerHeight()
      this.setCustomContainerHeight()
      if (!this.isLaptopView && !this.$route.fullPath.includes('control-panel')) {
        this.$store.commit('layout/SET_TAB_RIGHT_BAR', true)
      }
      checkIsTabView()
      checkIsMobileView()
      checkIsLaptopView()
    },
    setCustomContainerHeight() {
      if (this.$refs.customContainer) {
        this.$refs.customContainer.style.height = `${window.innerHeight}px`
      }
    },

    setTawkWidgetPosition() {
      // Set Tawk.to widget position and offsets
      if (typeof window !== 'undefined') {
        window.Tawk_API = window.Tawk_API || {}
        window.Tawk_API.customStyle = {
          visibility: {
            mobile: {
              position: 'br',
              xOffset: 0,
              yOffset: '80px',
            },
          },
        }
      }
    },

    applyNativeTawkBehavior() {
      if (!this.isCapacitorApp || !window?.Tawk_API) return
      if (isTawkToAllowed()) {
        showTawkWidget()
      } else {
        hideTawkWidget()
      }
    },

    getInstituteStats() {
      if (this.isAdmin) this.getInstituteCount()
    },

    handleClick({ type }) {
      const mutation = type === 'rightBar' ? 'SET_TAB_RIGHT_BAR' : 'SET_TAB_LEFT_BAR'
      this.$store.commit(`layout/${mutation}`)
    },

    mobileLeftBar() {
      this.$store.commit('layout/SET_TAB_LEFT_BAR')
      document.body.style.overflowY = 'hidden'
    },

    closeMobileLeftBar() {
      if (this.isTabView && this.tabLeftNav) {
        this.$store.commit('layout/SET_TAB_LEFT_BAR', false)
      }
    },

    closeMobileRightBar() {
      if (this.isLaptopView && this.tabRightNav) {
        setTimeout(() => this.$store.commit('layout/SET_TAB_RIGHT_BAR', false))
      }
    },

    async fetchInitialCampus() {
      const response = await this.getCampusList()
      this.setCampuses(response.data)
      if (this.currentCampusScope) this.getUserSpecificSectionsList()
    },

    setCampusData() {
      const campus = JSON.parse(localStorage.getItem('campus'))
      const campusClass = JSON.parse(localStorage.getItem('class'))
      const availableRoles = JSON.parse(localStorage.getItem('classRoles'))

      if (!this.currentSectionScope?.id && !this.currentCampusScope?.id) {
        this.setSelectedCampuse(campus)
        this.setcurrentSelectedSection(campusClass)
        if (availableRoles?.length) {
          this.setcurrentSelectedSectionRole(availableRoles[0])
        }
      }
    },

    checkLevelAuthentication(level = SCOPE_LEVELS.ROOT_LEVEL) {
      if (this.isAppLoading) return
      this.authenticRoute = null
      const { routes, defaultRoute } = this.leftBarContent

      routes.forEach((parent) => {
        if (parent.childs?.length) {
          this.childRouteAuthenticationHandler(parent, level)
        } else if (
          parent.route?.name === this.$route.name &&
          (!parent.basedOn || parent.basedOn.includes(level))
        ) {
          this.authenticRoute = true
        }
      })

      if (!this.authenticRoute) {
        setTimeout(() => {
          const route = getDefaultRoute(
            this.activeRole,
            this.currentCampusScope,
            this.currentSectionScope,
            defaultRoute,
          )
          this.$router?.push({ name: route })
        })
      }
    },

    findFeatureNameByRoute(features, routeName) {
      for (const feature of features) {
        if (feature.route?.name === routeName) {
          const level = this.getLevelVisibility(feature.basedOn)
          this.$store.commit('layout/SET_FEATURE_LEVEL', level)
        }
        if (feature.childs) this.findFeatureNameByRoute(feature.childs, routeName)
      }
    },

    childRouteAuthenticationHandler(parent, level) {
      parent.childs.forEach((child) => {
        if (
          child.route?.name === this.$route.name &&
          (!child.basedOn || child.basedOn.includes(level)) &&
          parent.basedOn?.includes(level)
        ) {
          this.authenticRoute = true
        }
      })
    },

    getHeaderContainerHeight() {
      if (this.$refs.headerContainer) {
        this.headerOffSetHeight = this.$refs.headerContainer.$el.clientHeight
        this.$store.commit('layout/SET_HEADER_OFF_SET_HEIGHT', this.headerOffSetHeight)
      }
    },

    ...mapActions('layout', [
      'setRightbarContent',
      'setcurrentSelectedSection',
      'setcurrentSelectedSectionRole',
      'setSelectedCampuse',
      'getCampusList',
      'getUserSpecificSectionsList',
      'setCampuses',
    ]),
    ...mapActions('instituteCount', ['getInstituteCount']),
  },
}
</script>

<style lang="scss" module>
@import '@src/design/_mediaquery-mixin.scss';

.mainContentGutters {
  @include media(null, 767px) {
    grid-column: span 16 / span 16;
  }
}

.leftBar {
  @include media(null, 767px) {
    transition: 0.5s;
  }
}
</style>

<style lang="scss">
.mobileLeftBar {
  left: 0 !important;
}
.sidebar-overlay {
  backdrop-filter: brightness(80%);
}
</style>
